import * as React from 'react';
export const IcSound = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.06 4.037a1.966 1.966 0 012.178-.43 1.973 1.973 0 011.235 1.845v13.215c0 .808-.46 1.51-1.2 1.833a1.98 1.98 0 01-2.16-.365l-4.285-3.973h-3.08a2.198 2.198 0 01-2.198-2.195l-.05-3.13c0-1.332.825-2.292 1.962-2.292h3.065l4.533-4.508zm7.797 14.585a.745.745 0 01-.577-.273.747.747 0 01.1-1.055c1.59-1.317 2.62-3.362 2.62-5.207 0-1.85-1.028-3.893-2.62-5.208a.747.747 0 01-.1-1.055.747.747 0 011.055-.1C21.257 7.312 22.5 9.81 22.5 12.087c0 2.275-1.243 4.773-3.165 6.363a.734.734 0 01-.478.172zm-1.927-2.41a.749.749 0 01-.44-1.357c.737-.538 1.62-1.453 1.62-2.768 0-1.315-.88-2.23-1.62-2.767a.748.748 0 01-.165-1.048.748.748 0 011.047-.165c1.443 1.05 2.238 2.463 2.238 3.983s-.795 2.932-2.238 3.982a.767.767 0 01-.442.14z'
      fill='currentColor'
    />
  </svg>
);
